import { Column, IconButton, Text, Tooltip } from '@dixa/lib-shared-habla';
import { HTMLAttributes } from 'react';

import { type MimSidekickMode } from '../../mimSidekickWidget';

type MimSidekickHeaderProps = {
  onClose: () => void;
  mode: MimSidekickMode;
  onToggleMode: () => void;
  dragHandleProps?: Pick<
    HTMLAttributes<HTMLDivElement>,
    'onPointerDown' | 'className'
  >;
};

export const MimSidekickHeader = ({
  onClose,
  mode,
  onToggleMode,
  dragHandleProps,
}: MimSidekickHeaderProps): JSX.Element => {
  const isDocked = mode === 'docked';

  return (
    <Column.Row slottable borderBottom {...dragHandleProps} noMinHeight>
      <Column.Slot>
        <Text.Heading variant="heading-3">Mim Sidekick</Text.Heading>
      </Column.Slot>
      <Column.Slot placement="end">
        <Tooltip content={isDocked ? 'Floating' : 'Sidebar'}>
          <IconButton
            icon={isDocked ? 'floating' : 'docked'}
            variant="tertiary"
            onClick={onToggleMode}
          />
        </Tooltip>
        <Tooltip content="Minimize">
          <IconButton icon="minus" variant="tertiary" onClick={onClose} />
        </Tooltip>
      </Column.Slot>
    </Column.Row>
  );
};
